import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { openExternalUrl } from "@/shared/openExternal";
import { Button } from "@/shared/ui";

import { adresseSurCyrano } from "./demenagementCyrano";

const IS_IN_TAURI =
  typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;

/** Le temps de lire l'écran avant d'être emmené. */
const SECONDES_AVANT_DEPART = 10;

/**
 * L'écran du chatteur qui revient sur dozka.app après la bascule : son espace
 * est sur cyrano.work (cf `demenagementCyrano.ts`). Il dit ce qui change — rien
 * que l'adresse — et comment se connecter, puis l'y emmène.
 *
 * Dans l'app desktop (webview Tauri), pas de départ automatique : la webview ne
 * navigue que sur dozka.app, le bouton ouvre le navigateur.
 */
export function DemenagementVersCyrano() {
  const { t } = useTranslation();
  const destination = adresseSurCyrano(window.location.pathname, window.location.search);
  const [reste, setReste] = useState(SECONDES_AVANT_DEPART);

  useEffect(() => {
    if (IS_IN_TAURI) return;
    if (reste <= 0) {
      window.location.replace(destination);
      return;
    }
    const id = window.setTimeout(() => setReste((s) => s - 1), 1000);
    return () => window.clearTimeout(id);
  }, [reste, destination]);

  const partir = () => {
    if (IS_IN_TAURI) void openExternalUrl(destination);
    else window.location.replace(destination);
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-6 bg-canvas px-8 py-12 text-center">
      <img src="/rejoindre/cyrano-logo.png" alt="Cyrano" className="h-12 w-auto opacity-95" />

      <div className="flex max-w-md flex-col gap-3">
        <h1 className="text-xl font-semibold text-fg">{t("shell.demenagementCyrano.title")}</h1>
        <p className="text-sm leading-relaxed text-muted">
          {t("shell.demenagementCyrano.subtitle")}
        </p>
        <p className="text-sm leading-relaxed text-muted">
          {t("shell.demenagementCyrano.connexion")}
        </p>
      </div>

      <Button variant="accent" size="xl" onClick={partir}>
        {t("shell.demenagementCyrano.bouton")}
      </Button>

      {!IS_IN_TAURI && (
        <p className="text-xs text-faint">
          {t("shell.demenagementCyrano.depart", { n: reste })}
        </p>
      )}
    </div>
  );
}
